import * as React from 'react';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import * as c from 'models/constants';
import { IUserPreferences } from 'models/user/userpreferences';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { ItemCardList, ProductFilters, SortRow, AddEntityItemCard, NoResults } from 'components';
import { ErrorPage } from 'containers';
import { ResultsWrapper } from 'components/PortalStructure';
import {
	IWardrobeItemSearchResultsData,
	IWardrobeItemSearchResultsAction,
} from 'models/search/productbasesearchresults';
import { getCategoryDomainValues } from 'modules/domainvalues';
import { IDomainValuesAction } from 'models/domainvalues/domainvalues';
import { ICategoryDomainValue, INodeDto, IDropdownData, IAuthContext } from 'models/common';
import { ProductBaseSearch } from 'redux/modules/search/productBaseSearch';
import {
	getWardrobeItemsSearchResults,
	setWardrobeItemSelectedCategory,
	setWardrobeItemsSortOrder,
	resetSearchData,
	setWardrobeItemSearchKeyword,
	deleteWardrobeItem,
} from 'redux/modules/search/wardrobeitemsearchresults';
import { Likes } from 'redux/modules/user/likes';
import { LikeNodeType } from 'models/enums/nodetype/likenodetype';
import { SearchUsage } from 'models/enums/searchusage';
import { closeModal, showModal } from 'redux/modules/modal';
import { IModalAction } from 'models/modal';
import { IUserCardData } from 'models/user/usercard';
import { RootCategory } from 'models/enums/rootcategory';
import { WardrobeItemsSort } from 'models/enums/sortvalues';
import { Wishlists } from 'redux/modules/user/wishlists';
import { WishlistNodeType } from 'models/enums/nodetype/wishlistnodetype';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';

interface IProps {
	wardrobeItemsSearchResultsData?: IWardrobeItemSearchResultsData;
	userPreferences?: IUserPreferences;
	userCard?: IUserCardData;
	categoryDomainValues?: ICategoryDomainValue[];
	categoryId?: string;
	location?: any;
	filterGender?: boolean;
	disableCardActions?: boolean;
	usage: SearchUsage;
	getWardrobeItemsSearchResults?: (
		isFirstLoad: boolean,
		isRefinement: boolean,
		usage: SearchUsage,
	) => IWardrobeItemSearchResultsAction;
	setWardrobeItemSelectedCategory?: (categoryId: number) => IWardrobeItemSearchResultsAction;
	setWardrobeItemSearchKeyword?: (searchKeyword: string) => IWardrobeItemSearchResultsAction;
	setWardrobeItemsSortOrder?: (sortOrder: number) => IWardrobeItemSearchResultsAction;
	resetSearchData?: () => IWardrobeItemSearchResultsAction;
	getCategoryDomainValues?: () => IDomainValuesAction;
	t?: (key: string) => string;
	selectItem?: (item: INodeDto) => void;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	deleteWardrobeItem?: (itemId: string) => void;
	goToCard: (id: string, type: string, target: string) => void;
	dispatch?: any;
	context?: IAuthContext;
}

interface IWardrobeItemSearchResultsItemCardList extends IItemCardList {
	wishlistItem: (itemType: string, itemId: string) => void;
	unwishItem: (itemType: string, itemId: string) => void;
}

@connect(
	(state: IStore) => ({
		wardrobeItemsSearchResultsData: state.wardrobeItemSearchResults,
		userPreferences: state.userPreferences,
		categoryDomainValues: state.domainValues.categories,
		userCard: state.usercard,
	}),
	(dispatch) => ({
		getWardrobeItemsSearchResults: (isFirstLoad: boolean, isRefinement: boolean, usage: SearchUsage) =>
			dispatch(getWardrobeItemsSearchResults(isFirstLoad, isRefinement, usage)),
		resetSearchData: () => dispatch(resetSearchData()),
		getCategoryDomainValues: () => dispatch(getCategoryDomainValues()),
		setWardrobeItemSelectedCategory: (categoryId: number) => dispatch(setWardrobeItemSelectedCategory(categoryId)),
		setWardrobeItemSearchKeyword: (searchKeyword: string) => dispatch(setWardrobeItemSearchKeyword(searchKeyword)),
		setWardrobeItemsSortOrder: (sortOrder: number) => dispatch(setWardrobeItemsSortOrder(sortOrder)),
		closeModal: () => dispatch(closeModal()),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
		deleteWardrobeItem: (itemId: string) => dispatch(deleteWardrobeItem(itemId)),
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class WardrobeItemSearchResultsComponent extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.loadMoreData = this.loadMoreData.bind(this);
		this.getWardrobeItemsSearchResults = this.getWardrobeItemsSearchResults.bind(this);
		this.handleOnRefinementClick = this.handleOnRefinementClick.bind(this);
		this.handleSetSelectedCategory = this.handleSetSelectedCategory.bind(this);
		this.handleOnSortClick = this.handleOnSortClick.bind(this);
		this.likeItem = this.likeItem.bind(this);
		this.unlikeItem = this.unlikeItem.bind(this);
		this.editItem = this.editItem.bind(this);
		this.deleteWardrobeItem = this.deleteWardrobeItem.bind(this);
		this.openDeleteWardrobeItem = this.openDeleteWardrobeItem.bind(this);
		this.openAddWardrobeItem = this.openAddWardrobeItem.bind(this);
		this.wishlist = this.wishlist.bind(this);
		this.unwish = this.unwish.bind(this);
	}

	public static defaultProps: Partial<IProps> = {
		filterGender: false,
	};

	public componentDidMount() {
		this.props.getCategoryDomainValues();
		if (
			this.props.usage === SearchUsage.WardrobeItemsUserCard ||
			this.props.usage === SearchUsage.OutfitWardrobeItems
		) {
			this.props.setWardrobeItemSelectedCategory(RootCategory.Women);
		}
	}

	public componentDidUpdate(prevProps: IProps) {
		if (
			!prevProps.userPreferences.id &&
			this.props.userPreferences.id &&
			this.props.wardrobeItemsSearchResultsData &&
			this.props.wardrobeItemsSearchResultsData.items.length > 0
		) {
			const likes = new Likes(LikeNodeType.WardrobeItemSearch);
			this.props.dispatch(likes.getLikedItems());
		}
	}

	public componentWillUnmount() {
		this.props.resetSearchData();
	}

	private loadMoreData() {
		this.getWardrobeItemsSearchResults(false, true, this.props.usage);
	}

	private getWardrobeItemsSearchResults(isFirstLoad: boolean, isRefinement: boolean, usage: SearchUsage) {
		this.props.getWardrobeItemsSearchResults(isFirstLoad, isRefinement, usage);
	}

	private handleOnRefinementClick(groupId: number, refinementId: number) {
		const productBase = new ProductBaseSearch(this.props.dispatch, c.NODE_TYPE_WARDROBE, this.props.usage);
		this.props.dispatch(productBase.refineProductSearch(groupId, refinementId));
	}

	private handleSetSelectedCategory(categoryId: number) {
		const lastSearchedKeyword = this.props.wardrobeItemsSearchResultsData.keyword;
		this.props.resetSearchData();
		this.props.setWardrobeItemSearchKeyword(lastSearchedKeyword);
		this.props.setWardrobeItemSelectedCategory(categoryId);
		this.props.getWardrobeItemsSearchResults(true, false, this.props.usage);
	}

	private handleOnSortClick(sortOrder: number) {
		this.props.setWardrobeItemsSortOrder(sortOrder);
		this.props.getWardrobeItemsSearchResults(true, false, this.props.usage);
	}

	private likeItem(_, itemId: string) {
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			const likes = new Likes(LikeNodeType.WardrobeItemSearch);
			this.props.dispatch(likes.likeItem(itemId));
		} else {
			signinRedirect();
		}
	}

	private unlikeItem(_, itemId: string) {
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			const likes = new Likes(LikeNodeType.WardrobeItemSearch);
			this.props.dispatch(likes.unlikeItem(itemId));
		} else {
			signinRedirect();
		}
	}

	private openDeleteWardrobeItem(_, itemId: string) {
		const dialogContent = (
			<div>
				<h2>{this.props.t('BSPortal_Common_ConfirmationDialog_Sure')}</h2>
				<p>{this.props.t('Wardrobe_WardrobeItems_DeleteUserMessage')}</p>
				<p>{this.props.t('BSPortal_Common_ConfirmationDialog_Confirm')}</p>
			</div>
		);

		this.props.showModal('ConfirmationDialog', {
			confirmAction: this.deleteWardrobeItem,
			value: itemId,
			yesButtonText: this.props.t('BSPortal_Common_YesDelete'),
			noButtonText: this.props.t('BSPortal_Common_NoWait'),
			content: dialogContent,
			closeModal: this.props.closeModal,
		});
	}

	private deleteWardrobeItem(confirm: boolean, itemId: string) {
		if (confirm) {
			this.props.deleteWardrobeItem(itemId);
		}
		this.props.closeModal();
	}

	private editItem(id: string) {
		this.props.showModal('EditWardrobeItem', {
			id,
			closeModal: this.props.closeModal,
			showModal: this.props.showModal,
		});
	}

	private openAddWardrobeItem() {
		this.props.showModal('CreateWardrobeItem', {
			closeModal: this.props.closeModal,
			showModal: this.props.showModal,
		});
	}

	private wishlist(_, itemId: string) {
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			const wishlists = new Wishlists(WishlistNodeType.WardrobeItemSearch);
			this.props.dispatch(wishlists.wishlist(itemId));
		} else {
			signinRedirect();
		}
	}

	private unwish(_, itemId: string) {
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			const wishlists = new Wishlists(WishlistNodeType.WardrobeItemSearch);
			this.props.dispatch(wishlists.unwish(itemId));
		} else {
			signinRedirect();
		}
	}

	public render() {
		if (this.props.wardrobeItemsSearchResultsData.error) {
			return <ErrorPage {...this.props} message={this.props.wardrobeItemsSearchResultsData.message} />;
		}

		const { items, itemsPage, refinementGroups, selectedCategoryId, sortOrder, isFetching, keyword } =
			this.props.wardrobeItemsSearchResultsData;
		const { t, categoryDomainValues } = this.props;

		if (!itemsPage) {
			return '';
		}

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: this.loadMoreData,
			hasMore: itemsPage ? itemsPage.totalItems > items.length : false,
			loader: <h4>{t('BSPortal_Common_Loading')}</h4>,
		};

		const listProps: IWardrobeItemSearchResultsItemCardList = {
			items,
			itemType: c.NODE_TYPE_WARDROBE_ITEM_CARD,
			isInfiniteScroll: true,
			infiniteScrollProps,
			currentUserId: this.props.userPreferences.id,
			likeItem: this.likeItem,
			unlikeItem: this.unlikeItem,
			selectItemObject: this.props.selectItem,
			isFetching,
			loadingText: t('BSPortal_Common_Loading'),
			noResults: <NoResults keyword={keyword} t={t} />,
			goToCard: this.props.goToCard,
			wishlistItem: this.wishlist,
			unwishItem: this.unwish,
			disableActions: this.props.disableCardActions,
		};

		const sortItems: IDropdownData[] = [];

		if (
			this.props.usage === SearchUsage.WardrobeItemsUserCard ||
			this.props.usage === SearchUsage.OutfitWardrobeItems
		) {
			listProps.currentUserIsAdministrator = this.props.userPreferences.isAdministrator;
			listProps.currentUserIsEditor = this.props.userPreferences.isEditor;
			listProps.editItem = this.editItem;
			listProps.deleteItem = this.openDeleteWardrobeItem;
			listProps.viewItem = (code: string) => {
				this.props.showModal('WardrobeItemCard', {
					code,
					closeModal: this.props.closeModal,
				});
			};

			if (this.props.userCard.isMyProfile && this.props.usage !== SearchUsage.OutfitWardrobeItems) {
				listProps.addItemCard = (
					<AddEntityItemCard action={this.openAddWardrobeItem} text={t('Wardrobe_WardrobeItems_AddWardrobeItem')} />
				);
			}
		}

		for (const n in WardrobeItemsSort) {
			if (typeof WardrobeItemsSort[n] === 'number') {
				sortItems.push({ key: WardrobeItemsSort[n], value: t('ProductsSearchResults_Sort_' + n) });
			}
		}

		const filterProps = {
			refinementGroups,
			categories: categoryDomainValues,
			selectedCategoryId,
			onRefinementClick: this.handleOnRefinementClick,
			setSelectedCategory: this.handleSetSelectedCategory,
			genderSelector: this.props.filterGender,
		};

		const filter = <ProductFilters {...filterProps} />;

		const sortRowProps = {
			entityData: null,
			items: sortItems,
			selectedItem: sortOrder,
			onSortClick: this.handleOnSortClick,
		};

		const sortRow = <SortRow {...sortRowProps} />;

		return (
			<ResultsWrapper complexFilter={filter} sortComponent={sortRow}>
				<ItemCardList {...listProps} />
			</ResultsWrapper>
		);
	}
}

const WardrobeItemSearchResults = withAuthContext(WardrobeItemSearchResultsComponent);

export { WardrobeItemSearchResults };
